import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { Container, Section } from '../global';

const StyledSection = styled(Section)`
  background-color: ${(props) => props.theme.color.background.white};
  /* clip-path: polygon(0 7%, 100% 4%, 100% 100%, 0% 100%); */
  /* clip-path: polygon(0 0, 100% 14%, 100% 100%, 0% 100%); */
`;

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px 10px 0px 10px;

  @media (min-width: ${(props) => props.theme.screen.xs}) {
    max-width: 540px;
  }

  @media (min-width: ${(props) => props.theme.screen.sm}) {
    max-width: 540px;
  }

  @media (min-width: ${(props) => props.theme.screen.md}) {
    max-width: 720px;
  }

  @media (min-width: ${(props) => props.theme.screen.lg}) {
    max-width: 960px;
  }
`;

const GetStartedTitle = styled.h3`
  margin: 0 auto 32px;
  text-align: center;
`;

const P = styled.p`
  text-align: justify;
`;

const AboutUs = () => (
  <StyledSection id="aboutUs">
    <StyledContainer>
      <FormattedMessage
        id="aboutUs"
        values={{
          GetStartedTitle: (...chunks) => (
            <GetStartedTitle>{chunks}</GetStartedTitle>
          ),
          P: (...chunks) => <P>{chunks}</P>,
        }}
      />
    </StyledContainer>
  </StyledSection>
);

export default AboutUs;
